import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

import { CartCardBody, CartCardHeader } from '@/components/atomic/atoms';
import { Text } from '@/components/atomic/nuclei';
import { CART_STATUS, staticMediaStoreBaseURL } from '@/config/common';
import { useIsMobile } from '@/helpers/screenResolutionHelper';
import { getPageURL, ROUTE_CONFIG } from '@/services/hostPortal.service';

const CartCard = ({ cartCard } = {}) => {
  const { cartName, cartNumber, cartOrder, createdAt, opsUser, status } =
    cartCard;

  const cartCreatedBy = opsUser?.name || 'NA';

  return (
    <div
      className={`py-3 my-5 md:border text-sm md:text-base border-[#F3F3F6] rounded-lg px-4 md:px-3 bg-lightgray font-medium hover:border-cinnabar shadow-event cursor-pointer relative`}
    >
      <CartCardHeader
        {...{
          cartName,
          cartNumber,
          cartOrder,
          status
        }}
      />
      <CartCardBody
        {...{
          cartCreatedBy,
          cartOrder,
          createdAt,
          status
        }}
      />
    </div>
  );
};

const onCartCardClick = ({ cartCard, router }) => {
  const { cartOrder, id, status } = cartCard;
  if (status === CART_STATUS.ORDER.value) {
    const orderId = cartOrder?.order?.id;
    const pathForOrderedCart = getPageURL({
      pageName: ROUTE_CONFIG.ORDER_DETAILS.label,
      pathParams: {
        orderId
      }
    });
    return router.push(pathForOrderedCart);
  }
  const cartPath = getPageURL({
    pageName: ROUTE_CONFIG.HOST_CART.label,
    pathParams: {
      cartId: id
    }
  });
  return router.push(cartPath);
};

const CartList = ({ showControlToCollapseList, title, userEventCartList }) => {
  const router = useRouter();
  const [isMobile] = useIsMobile();
  const [showCartCardList, setShowCartCardList] = useState(true);

  return (
    <div>
      <div className='flex items-center gap-2 mt-6'>
        <Text
          {...{
            className:
              'text-base md:text-xl font-medium font-Montserrat flex self-center',
            content: title
          }}
        />
        {showControlToCollapseList && (
          <Image
            {...{
              alt: 'show hide details',
              className: `cursor-pointer transform ${
                showCartCardList ? 'rotate-0' : '-rotate-90'
              }`,
              height: isMobile ? 12 : 14,
              onClick: () => setShowCartCardList(!showCartCardList),
              src: `${staticMediaStoreBaseURL}/icons/down-arrow.svg`,
              width: isMobile ? 12 : 14
            }}
          />
        )}
      </div>
      <div>
        {showCartCardList &&
          userEventCartList.map((cartCard) => (
            <div
              id='cartCard'
              key={cartCard.cartNumber}
              onClick={() => onCartCardClick({ cartCard, router })}
            >
              <CartCard
                key={cartCard.id}
                {...{ cartCard }}
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default CartList;
